module.exports = __webpack_public_path__ + "static/gurleen-e97d4087a86e28264d753b4fe3d3dd93.jpeg";